import React from 'react'
import { formatNumber } from '../../shared/constants'
import StatusTable from './StatusTable'

export default function ProductStatus() {
  const tableData = (item, tableHeadings) => {
    //console.log('STATUS : ', item.status)
    let tempData = []
    tableHeadings && tableHeadings.map((val) => tempData.push({ value: item[val] }))

    return tempData
  }
  return <StatusTable key="Product" tableData={tableData} module="PRODUCT" />
}
